(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kodo-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-kodo-welcome]');
    if (!root) return;
    var KEY = 'kodoWelcome';
    var always = root.dataset.always === 'true';
    var auto = root.dataset.auto === 'true';
    var posted = /[?&]customer_posted=true/.test(location.search);
    var state = null;
    try { state = localStorage.getItem(KEY); } catch (e) {}
    var tab = document.querySelector('[data-kwp-tab]');

    function remember(v) { state = v; try { localStorage.setItem(KEY, v); } catch (e) {} }
    function open() { root.hidden = false; document.documentElement.style.overflow = 'hidden'; if (tab) tab.hidden = true; }
    function showTab() { if (tab && state !== 'done' && state !== 'gone') tab.hidden = false; }
    function close() {
      root.hidden = true;
      document.documentElement.style.overflow = '';
      // Closing the welcome (step two) means the email is already ours; closing
      // the ask means it is not, and the tab keeps the offer within reach.
      if (posted || state === 'done') remember('done');
      else { remember('dismissed'); showTab(); }
    }
    function step(n) {
      root.querySelectorAll('[data-kwp-step]').forEach(function (el) { el.hidden = el.dataset.kwpStep !== String(n); });
    }

    root.querySelectorAll('[data-kwp-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
    var apply = root.querySelector('[data-kwp-apply]');
    if (apply) apply.addEventListener('click', function () { remember('done'); });

    if (tab) {
      tab.querySelector('[data-kwp-tab-open]').addEventListener('click', function () { step(1); open(); });
      tab.querySelector('[data-kwp-tab-close]').addEventListener('click', function () { tab.hidden = true; remember('gone'); });
    }

    // The announcement bar's "First order 10% off" (and any other link ending
    // in #first-order) opens the card: the code again if the email is already
    // ours, the ask otherwise. Delegated, since the announcement bar is
    // rendered by the theme and may re-render.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="#first-order"]');
      if (!a) return;
      e.preventDefault();
      step(state === 'done' ? 2 : 1);
      open();
    });

    if (posted) {
      // Back from Shopify with the email taken: straight to the welcome and the code.
      step(2);
      open();
      remember('done');
      if (history.replaceState) {
        var u = new URL(location.href); u.searchParams.delete('customer_posted'); history.replaceState(null, '', u.pathname + u.search + u.hash);
      }
      return;
    }
    if (!auto) return;                                             // not the homepage, or the setting is off: opens only from the link
    if (window.Shopify && window.Shopify.designMode) return;
    if (location.pathname.indexOf('/checkout') !== -1) return;
    if (state === 'dismissed' && !always) { showTab(); return; }  // closed the ask before: keep the tab
    if (state && !always) return;                                  // already taken, or the tab closed too
    step(1);
    setTimeout(open, (parseFloat(root.dataset.delay) || 3) * 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
